import AntTime from '../utils/AntTime';
import AntLocalization from '../utils/AntLocalization';
import AntCondition from '../utils/AntCondition';
import format from 'string-format';

export default class AntCardViewUtil {
    constructor(config, tableName) {
        this.config = config;
        this.tableName = tableName;
    }

    initFieldConfig(field) {
        var strField = field.cnfField ? field.cnfField : field.dataField;
        var found = this.config.getCnfField(strField, field.cnfTable);

        var obj = {
            dataField: field.dataField,
            table: field.cnfTable,
            cnf: found
        };

        obj.dataType = field.dataType ? field.dataType : found && found.dataType ? found.dataType : null;
        obj.label = field.label ? field.label : found && found.gridLabel ? found.gridLabel : found && found.label ? found.label : null;

        obj.label = AntLocalization.translateText(AntCondition.getValue({}, obj.label));

        obj.lookupValues =
            field.lookup && field.lookup.values instanceof Array
                ? field.lookup.values
                : found && found.lookup && found.lookup.values instanceof Array
                ? found.lookup.values
                : null;
        if (obj.lookupValues instanceof Array)
            obj.lookupValues = obj.lookupValues.map((c) => {
                c.name = AntLocalization.translateText(AntCondition.getValue({}, c.name));
                return c;
            });

        obj.alignment = found && found.alignment !== undefined ? found.alignment : field.alignment;

        if (!obj.alignment) {
            if (obj.dataType === 'currency') obj.alignment = 'right';
            else if (obj.dataType === 'float' || obj.dataType === 'decimal') obj.alignment = 'right';
            else if (obj.dataType === 'int') obj.alignment = 'right';
        }

        return obj;
    }

    isFieldVisible(props, cell, data) {
        if (cell.visible === true) return true;
        if (cell.visible === false) return false;

        if (cell && cell.hideWhenSelected && props && props.isSelected) return false;

        var visible = AntCondition.isVisible(data, cell);
        if (visible && cell.visibleOnMain) {
            let vObj = cell.visibleOnMain;
            if (cell.visibleOnMain instanceof Array) {
                vObj = cell.visibleOnMain.find(
                    (v) =>
                        v.table === this.tableName ||
                        (v.table instanceof Array && v.table.includes(this.tableName)) ||
                        (v.tables instanceof Array && v.tables.includes(this.tableName))
                );

                if (vObj) vObj = vObj.value;
            }
            if (vObj)
                visible = AntCondition.isVisible(data, {
                    visible: vObj
                });
        }

        var cellCnf;
        if (visible && cell.dataField) {
            var cnfTable = cell.cnfTable ? cell.cnfTable : this.tableName;

            cellCnf = this.initFieldConfig({
                dataField: cell.dataField,
                dataType: cell.dataType,
                cnfTable: cnfTable,
                cnfField: cell.cnfField
            });
            if (cellCnf) {
                visible = AntCondition.isVisible(null, cellCnf.cnf);
                if (visible && cellCnf.cnf.visibleOnMain) {
                    let vObj = cellCnf.cnf.visibleOnMain;
                    if (cellCnf.cnf.visibleOnMain instanceof Array) {
                        vObj = cellCnf.cnf.visibleOnMain.find(
                            (v) =>
                                v.table === this.tableName ||
                                (v.table instanceof Array && v.table.includes(this.tableName)) ||
                                (v.tables instanceof Array && v.tables.includes(this.tableName))
                        );

                        if (vObj) vObj = vObj.value;
                    }
                    if (vObj)
                        visible = AntCondition.isVisible(data, {
                            visible: vObj
                        });
                }

                if (visible && cellCnf.cnf.visibleSelf) {
                    visible = AntCondition.isVisible(data, {
                        visible: cellCnf.cnf.visibleSelf
                    });
                }
            }
        }

        if (props.filterGroup) {
            if (visible && cellCnf && cellCnf.cnf && cellCnf.cnf.visibleFilterGroups instanceof Array) {
                visible = cellCnf.cnf.visibleFilterGroups.includes(props.filterGroup);
            }

            if (visible && cell.visibleFilterGroups instanceof Array) {
                visible = cell.visibleFilterGroups.includes(props.filterGroup);
            }
        }

        if (visible && cell.visible && typeof cell.visible === 'object' && cell.visible.type === 'action') {
            if (cell.visible.field) {
                var condKey = Object.keys(props.searchConditions).find((k) => k === cell.visible.field);
                if (condKey && props.searchConditions[condKey] !== undefined) visible = props.searchConditions[condKey] === cell.visible.value;
            }
        }

        if (cell && cell.showWhenSelected) return visible && Boolean(props.isSelected);

        return visible;
    }

    formatFieldValue(props, cell, data, fValue, _cellCnf) {
        var newValue = fValue;

        var cellCnf;
        if (_cellCnf) cellCnf = _cellCnf;

        var cnf;
        if (cellCnf) cnf = cellCnf.cnf;
        else {
            if (cell.dataField) {
                var cnfTable = cell.cnfTable ? cell.cnfTable : this.tableName;
                cellCnf = this.initFieldConfig({
                    dataField: cell.dataField,
                    dataType: cell.dataType,
                    cnfTable: cnfTable,
                    cnfField: cell.cnfField
                });
                if (cellCnf) cnf = cellCnf.cnf;
            }
        }

        var dataType = cell.dataType;
        if (!dataType && cellCnf) dataType = cellCnf.dataType;
        if (!dataType && cnf) dataType = cnf.dataType;

        dataType = AntCondition.getValue(data, dataType);

        let lookupValues = cellCnf ? cellCnf.lookupValues : undefined;
        if (lookupValues instanceof Array) {
            if (data) {
                var valueField = cell.valueField ? cell.valueField : cnf && cnf.lookup && cnf.lookup.valueField ? cnf.lookup.valueField : 'code';

                var displayField = cell.displayField
                    ? cell.displayField
                    : cnf && cnf.lookup && cnf.lookup.displayField
                    ? cnf.lookup.displayField
                    : 'name';

                if (fValue != null) {
                    var obj = lookupValues.find((f) => f[valueField] === fValue);
                    if (obj) newValue = obj[displayField];
                }

                if (cell.customDisplay) newValue = cell.customDisplay(data);
                else if (cnf && cnf.customDisplay) newValue = cnf.customDisplay(data);

                if (typeof newValue === 'string') newValue = String(newValue);
                if (newValue === null || newValue === undefined) newValue = '';

                return newValue;
            }
        }

        if (dataType === 'Array' && !cell.dataField && cell.fields instanceof Array) {
            newValue = cell.fields
                .map((field) => {
                    if (field && typeof field === 'object' && field.dataField) {
                        if (field.visible === false) return;
                    }

                    let fName = field && typeof field === 'object' && field.dataField ? field.dataField : field;
                    let fValue = data[fName];
                    let visible = false;

                    if (cell.visible === true) visible = true;

                    if (!visible)
                        visible = this.isFieldVisible(
                            props,
                            {
                                dataField: fName
                            },
                            data
                        );

                    if (field && typeof field === 'object' && field.dataField && (!visible || field.visible !== undefined)) {
                        if (field.visible === true) visible = true;
                        else
                            visible = AntCondition.isVisible(data, {
                                visible: field.visible
                            });

                        if (field.visibleOnMain)
                            visible =
                                visible &&
                                AntCondition.isVisible(props.parentData, {
                                    visible: field.visibleOnMain
                                });
                    }

                    if (visible) {
                        var tableName = cell.cnfTable ? cell.cnfTable : this.tableName;

                        var cellCnf2 = this.initFieldConfig({
                            dataField: field,
                            cnfTable: tableName
                        });
                        fValue = this.formatFieldValue(
                            props,
                            {
                                ...field,
                                dataField: field
                            },
                            data,
                            fValue,
                            cellCnf2
                        );

                        if (typeof fValue === 'string') fValue = String(fValue);
                        if (fValue === AntLocalization.translateText({ vi: 'Không', en: 'None', fr: 'Aucun', es: 'Ninguno', id: 'Tidak ada', ja: 'なし', zh: '无', ko: '없음', hi: 'कोई नहीं', ar: 'لا شيء' }) && cell.displayNoneAsEmpty !== false) fValue = '';
                        if (fValue === null || fValue === undefined) fValue = '';

                        if (fValue && parseInt(fValue) && String(fName).endsWith('_adm2_name'))
                            fValue = AntLocalization.translateText({ vi: 'Quận', en: 'Dist', fr: 'District', es: 'Distrito', id: 'Distrik', ja: '地区', zh: '区', ko: '구역', hi: 'जिला', ar: 'منطقة' }) + ' ' + fValue;

                        // if (field?.showWithText) {
                        //     let strText = '';

                        //     if (field.label) {
                        //         var gLabel = AntCondition.getValue(data, field.label);
                        //         strText = AntLocalization.translateText(gLabel);
                        //     }

                        //     if (!strText && cellCnf2 && cellCnf2.label) {
                        //         var gLabel = AntCondition.getValue(data, cellCnf2.label);
                        //         strText = AntLocalization.translateText(gLabel);
                        //     }
                        //     if (strText) fValue = strText + ': ' + String(fValue);
                        // }

                        return fValue;
                    }
                })
                .filter((v) => v !== undefined && v !== 0 && v !== null && String(v).trim() !== '');

            if (cell.selectTop) newValue = newValue.join(',').split(',').slice(0, cell.selectTop);
        }
        if (dataType === 'int') {
            newValue = AntLocalization.translateInteger(fValue);
        }

        if (dataType === 'float' || dataType === 'decimal') {
            newValue = AntLocalization.translateDecimal(fValue);
        }

        if (dataType === 'percent') {
            newValue = String(AntLocalization.translateInteger(Math.floor(parseFloat(fValue) * 100))) + ' %';
        }

        if (dataType === 'day') {
            var lblValue = AntLocalization.translateText({
                vi: 'ngày',
                en: fValue > 1 ? 'days' : 'day'
            , fr: fValue > 1 ? 'jours' : 'jour', es: fValue > 1 ? 'días' : 'día', id: 'hari', ja: '日', zh: '天', ko: '일', hi: 'दिन', ar: fValue > 1 ? 'أيام' : 'يوم' });

            newValue = String(AntLocalization.translateInteger(fValue)) + ' ' + lblValue;
        }

        if (dataType === 'month') {
            if (data && data[cell.dataField] != null) {
                var value = parseFloat(data[cell.dataField]);
                if (value) {
                    if (String(value).length > 6) {
                        newValue = AntTime.fromUnix(value).format('MM/YYYY');
                    } else newValue = AntTime.fromString(format('{0}-{1}-01 00:01', Math.floor(value / 100), value % 100)).format('MM/YYYY');
                }
            }
        }

        if (dataType === 'year') {
            if (data && data[cell.dataField] != null) {
                var value = parseFloat(data[cell.dataField]);
                if (value) {
                    if (String(value).length > 6) {
                        newValue = AntTime.fromUnix(value).format('YYYY');
                    } else newValue = AntTime.fromString(format('{0}-01-01 00:01', parseInt(value))).format('YYYY');
                }
            }
        }

        if (dataType === 'period') {
            var lblValue = AntLocalization.translateText({ vi: 'kỳ', en: 'period', fr: 'période', es: 'período', id: 'periode', ja: '期間', zh: '期', ko: '기간', hi: 'अवधि', ar: 'فترة' });

            newValue = String(AntLocalization.translateInteger(fValue)) + ' ' + lblValue;
        }

        if (dataType === 'currency') {
            newValue = AntLocalization.translateCurrency(
                fValue,
                cell.showSign !== undefined ? cell.showSign : cnf && cnf.showSign !== undefined ? cnf.showSign : false
            );
        }

        if (dataType === 'date') {
            if (!fValue) newValue = '';
            else if (AntTime.isUnixWithinToDay(fValue)) {
                if (cell.showTimeWithinToday) newValue = AntTime.fromUnix(fValue).format('hh:mm A ');
                else
                    newValue = AntLocalization.translateText({ vi: 'Hôm nay', en: 'Today', fr: 'Aujourd\'hui', es: 'Hoy', id: 'Hari ini', ja: '今日', zh: '今天', ko: '오늘', hi: 'आज', ar: 'اليوم' });
            } else if (AntTime.isUnixWithinYesterday(fValue))
                newValue = AntLocalization.translateText({ vi: 'Hôm qua', en: 'Yesterday', fr: 'Hier', es: 'Ayer', id: 'Kemarin', ja: '昨日', zh: '昨天', ko: '어제', hi: 'कल (बीता)', ar: 'أمس' });
            else if (AntTime.isUnixWithinTomorrow(fValue))
                newValue = AntLocalization.translateText({ vi: 'Ngày mai', en: 'Tomorrow', fr: 'Demain', es: 'Mañana', id: 'Besok', ja: '明日', zh: '明天', ko: '내일', hi: 'कल (आने वाला)', ar: 'غداً' });
            else if (AntTime.isUnixWithinCurrentYear(fValue)) newValue = AntTime.fromUnix(fValue).format('DD/MM');
            else newValue = AntTime.fromUnix(fValue).format('DD/MM/YY');
        }

        if (dataType === 'datetime') {
            if (!fValue) newValue = '';
            else if (AntTime.isUnixWithinToDay(fValue)) newValue = AntTime.fromUnix(fValue).format('hh:mm A');
            else if (AntTime.isUnixWithinCurrentYear(fValue)) newValue = AntTime.fromUnix(fValue).format('DD/MM HH:mm');
            else newValue = AntTime.fromUnix(fValue).format('DD/MM/YY');
        }

        if (dataType === 'weekday') {
            if (!fValue) newValue = '';
            else {
                const dayOfWeek = parseInt(AntTime.fromUnix(fValue).isoWeekday());
                if (dayOfWeek === 1)
                    newValue = AntLocalization.translateText({ vi: 'Thứ Hai', en: 'Monday', fr: 'Lundi', es: 'Lunes', id: 'Senin', ja: '月曜日', zh: '星期一', ko: '월요일', hi: 'सोमवार', ar: 'الإثنين' });
                if (dayOfWeek === 2)
                    newValue = AntLocalization.translateText({ vi: 'Thứ Ba', en: 'Tuesday', fr: 'Mardi', es: 'Martes', id: 'Selasa', ja: '火曜日', zh: '星期二', ko: '화요일', hi: 'मंगलवार', ar: 'الثلاثاء' });
                if (dayOfWeek === 3)
                    newValue = AntLocalization.translateText({ vi: 'Thứ Tư', en: 'Wednesday', fr: 'Mercredi', es: 'Miércoles', id: 'Rabu', ja: '水曜日', zh: '星期三', ko: '수요일', hi: 'बुधवार', ar: 'الأربعاء' });
                if (dayOfWeek === 4)
                    newValue = AntLocalization.translateText({ vi: 'Thứ Năm', en: 'Thursday', fr: 'Jeudi', es: 'Jueves', id: 'Kamis', ja: '木曜日', zh: '星期四', ko: '목요일', hi: 'गुरुवार', ar: 'الخميس' });
                if (dayOfWeek === 5)
                    newValue = AntLocalization.translateText({ vi: 'Thứ Sáu', en: 'Friday', fr: 'Vendredi', es: 'Viernes', id: 'Jumat', ja: '金曜日', zh: '星期五', ko: '금요일', hi: 'शुक्रवार', ar: 'الجمعة' });
                if (dayOfWeek === 6)
                    newValue = AntLocalization.translateText({ vi: 'Thứ Bảy', en: 'Saturday', fr: 'Samedi', es: 'Sábado', id: 'Sabtu', ja: '土曜日', zh: '星期六', ko: '토요일', hi: 'शनिवार', ar: 'السبت' });
                if (dayOfWeek === 7)
                    newValue = AntLocalization.translateText({ vi: 'Chủ Nhật', en: 'Sunday', fr: 'Dimanche', es: 'Domingo', id: 'Minggu', ja: '日曜日', zh: '星期日', ko: '일요일', hi: 'रविवार', ar: 'الأحد' });
            }
        }
        

        if (dataType === 'duration') {
            if (cell.customCellValue) newValue = cell.customCellValue(data);
            if (!fValue) newValue = '';
            else {
                var minutes = AntTime.diffMinuteToNow(fValue, true);
                minutes = Math.ceil(minutes);

                var vDays = Math.floor(Math.abs(minutes) / (60 * 24));
                var vHours = Math.floor(Math.abs(minutes) / 60) - vDays * 24;
                var vMinutes = Math.abs(minutes) - Math.floor(Math.abs(minutes) / 60) * 60;

                let strDays = 'd';
                let strHours = 'h';
                let strMinutes = 'm';

                if (vDays)
                    // fValue = [
                    //     vDays ? format('{0} {1}', vDays, AntLocalization.translateText({ vi: 'ngày', en: vDays > 1 ? 'days' : 'day' , fr: vDays > 1 ? 'jours' : 'jour', es: vDays > 1 ? 'días' : 'día', id: 'hari', ja: '日', zh: '天', ko: '일', hi: 'दिन', ar: vDays > 1 ? 'أيام' : 'يوم' })) : null,
                    //     vHours ? format('{0} {1}', vHours, AntLocalization.translateText({ vi: 'giờ', en: vHours > 1 ? 'hours' : 'hour' , fr: vHours > 1 ? 'heures' : 'heure', es: vHours > 1 ? 'horas' : 'hora', id: 'jam', ja: '時間', zh: '小时', ko: '시간', hi: 'घंटे', ar: vHours > 1 ? 'ساعات' : 'ساعة' })) : null
                    // ];
                    fValue = [vDays ? format('{0}{1}', vDays, strDays) : null, vHours ? format('{0}{1}', vHours, strHours) : null];
                else if (vHours)
                    // fValue = [
                    //     vHours ? format('{0} {1}', vHours, AntLocalization.translateText({ vi: 'giờ', en: vHours > 1 ? 'hours' : 'hour' , fr: vHours > 1 ? 'heures' : 'heure', es: vHours > 1 ? 'horas' : 'hora', id: 'jam', ja: '時間', zh: '小时', ko: '시간', hi: 'घंटे', ar: vHours > 1 ? 'ساعات' : 'ساعة' })) : null,
                    //     vMinutes
                    //         ? format('{0} {1}', vMinutes, AntLocalization.translateText({ vi: 'phút', en: vMinutes > 1 ? 'minutes' : 'minute' , fr: vMinutes > 1 ? 'minutes' : 'minute', es: vMinutes > 1 ? 'minutos' : 'minuto', id: 'menit', ja: '分', zh: '分钟', ko: '분', hi: 'मिनट', ar: vMinutes > 1 ? 'دقائق' : 'دقيقة' }))
                    //         : null
                    // ];
                    fValue = [vHours ? format('{0}{1}', vHours, strHours) : null, vMinutes ? format('{0}{1}', vMinutes, strMinutes) : null];
                else
                    fValue = [
                        vMinutes
                            ? format('{0} {1}', vMinutes, AntLocalization.translateText({ vi: 'phút', en: vMinutes > 1 ? 'minutes' : 'minute' , fr: vMinutes > 1 ? 'minutes' : 'minute', es: vMinutes > 1 ? 'minutos' : 'minuto', id: 'menit', ja: '分', zh: '分钟', ko: '분', hi: 'मिनट', ar: vMinutes > 1 ? 'دقائق' : 'دقيقة' }))
                            : null
                    ];

                fValue = fValue.filter((v) => Boolean(v)).join(' ');
                if (minutes < 0) fValue = format('{1} {0}', fValue, AntLocalization.translateText({ vi: 'Còn', en: 'Remain', fr: 'Reste', es: 'Quedan', id: 'Sisa', ja: '残り', zh: '剩余', ko: '남은', hi: 'शेष', ar: 'متبقي' }));

                newValue = fValue;
            }
        }
        if (dataType === 'minute' || dataType === 'minutes') {
            if (cell.customCellValue) newValue = cell.customCellValue(data);
            else {
                if (cell.dataUOMField) {
                    let uom = data[cell.dataUOMField];
                    if (uom === 'HOUR') newValue = newValue * 60;
                    if (uom === 'DAY') newValue = newValue * 60 * 24;
                }
            }

            if (!fValue) newValue = '';

            var minutes = Math.ceil(newValue);

            var vDays = Math.floor(Math.abs(minutes) / (60 * 24));
            var vHours = Math.floor(Math.abs(minutes) / 60) - vDays * 24;
            var vMinutes = Math.abs(minutes) - Math.floor(Math.abs(minutes) / 60) * 60;

            if (vDays)
                fValue = [
                    vDays
                        ? format(
                              '{0} {1}',
                              vDays,
                              AntLocalization.translateText({
                                  vi: 'ngày',
                                  en: vDays > 1 ? 'days' : 'day'
                              , fr: vDays > 1 ? 'jours' : 'jour', es: vDays > 1 ? 'días' : 'día', id: 'hari', ja: '日', zh: '天', ko: '일', hi: 'दिन', ar: vDays > 1 ? 'أيام' : 'يوم' })
                          )
                        : null,
                    vHours
                        ? format(
                              '{0} {1}',
                              vHours,
                              AntLocalization.translateText({
                                  vi: 'giờ',
                                  en: vHours > 1 ? 'hours' : 'hour'
                              , fr: vHours > 1 ? 'heures' : 'heure', es: vHours > 1 ? 'horas' : 'hora', id: 'jam', ja: '時間', zh: '小时', ko: '시간', hi: 'घंटे', ar: vHours > 1 ? 'ساعات' : 'ساعة' })
                          )
                        : null
                ];
            else if (vHours)
                fValue = [
                    vHours
                        ? format(
                              '{0} {1}',
                              vHours,
                              AntLocalization.translateText({
                                  vi: 'giờ',
                                  en: vHours > 1 ? 'hours' : 'hour'
                              , fr: vHours > 1 ? 'heures' : 'heure', es: vHours > 1 ? 'horas' : 'hora', id: 'jam', ja: '時間', zh: '小时', ko: '시간', hi: 'घंटे', ar: vHours > 1 ? 'ساعات' : 'ساعة' })
                          )
                        : null,
                    vMinutes
                        ? format(
                              '{0} {1}',
                              vMinutes,
                              AntLocalization.translateText({
                                  vi: 'phút',
                                  en: vMinutes > 1 ? 'minutes' : 'minute'
                              , fr: vMinutes > 1 ? 'minutes' : 'minute', es: vMinutes > 1 ? 'minutos' : 'minuto', id: 'menit', ja: '分', zh: '分钟', ko: '분', hi: 'मिनट', ar: vMinutes > 1 ? 'دقائق' : 'دقيقة' })
                          )
                        : null
                ];
            else
                fValue = [
                    vMinutes
                        ? format(
                              '{0} {1}',
                              vMinutes,
                              AntLocalization.translateText({
                                  vi: 'phút',
                                  en: vMinutes > 1 ? 'minutes' : 'minute'
                              , fr: vMinutes > 1 ? 'minutes' : 'minute', es: vMinutes > 1 ? 'minutos' : 'minuto', id: 'menit', ja: '分', zh: '分钟', ko: '분', hi: 'मिनट', ar: vMinutes > 1 ? 'دقائق' : 'دقيقة' })
                          )
                        : null
                ];

            fValue = fValue.filter((v) => Boolean(v)).join(' ');

            newValue = fValue;
        }

        if (dataType === 'hour' || dataType === 'hours') {
            if (cell.customCellValue) newValue = cell.customCellValue(data);
            else {
                if (cell.dataUOMField) {
                    let uom = data[cell.dataUOMField];
                    if (uom === 'DAY') newValue = newValue * 24;
                }
            }

            if (!fValue) newValue = '';

            var minutes = Math.ceil(newValue * 60);

            var vDays = Math.floor(Math.abs(minutes) / (60 * 24));
            var vHours = Math.floor(Math.abs(minutes) / 60) - vDays * 24;
            var vMinutes = Math.abs(minutes) - Math.floor(Math.abs(minutes) / 60) * 60;

            if (vDays)
                fValue = [
                    vDays
                        ? format(
                              '{0} {1}',
                              vDays,
                              AntLocalization.translateText({
                                  vi: 'ngày',
                                  en: vDays > 1 ? 'days' : 'day'
                              , fr: vDays > 1 ? 'jours' : 'jour', es: vDays > 1 ? 'días' : 'día', id: 'hari', ja: '日', zh: '天', ko: '일', hi: 'दिन', ar: vDays > 1 ? 'أيام' : 'يوم' })
                          )
                        : null,
                    vHours
                        ? format(
                              '{0} {1}',
                              vHours,
                              AntLocalization.translateText({
                                  vi: 'giờ',
                                  en: vHours > 1 ? 'hours' : 'hour'
                              , fr: vHours > 1 ? 'heures' : 'heure', es: vHours > 1 ? 'horas' : 'hora', id: 'jam', ja: '時間', zh: '小时', ko: '시간', hi: 'घंटे', ar: vHours > 1 ? 'ساعات' : 'ساعة' })
                          )
                        : null
                ];
            else if (vHours)
                fValue = [
                    vHours
                        ? format(
                              '{0} {1}',
                              vHours,
                              AntLocalization.translateText({
                                  vi: 'giờ',
                                  en: vHours > 1 ? 'hours' : 'hour'
                              , fr: vHours > 1 ? 'heures' : 'heure', es: vHours > 1 ? 'horas' : 'hora', id: 'jam', ja: '時間', zh: '小时', ko: '시간', hi: 'घंटे', ar: vHours > 1 ? 'ساعات' : 'ساعة' })
                          )
                        : null,
                    vMinutes
                        ? format(
                              '{0} {1}',
                              vMinutes,
                              AntLocalization.translateText({
                                  vi: 'phút',
                                  en: vMinutes > 1 ? 'minutes' : 'minute'
                              , fr: vMinutes > 1 ? 'minutes' : 'minute', es: vMinutes > 1 ? 'minutos' : 'minuto', id: 'menit', ja: '分', zh: '分钟', ko: '분', hi: 'मिनट', ar: vMinutes > 1 ? 'دقائق' : 'دقيقة' })
                          )
                        : null
                ];
            else
                fValue = [
                    vMinutes
                        ? format(
                              '{0} {1}',
                              vMinutes,
                              AntLocalization.translateText({
                                  vi: 'phút',
                                  en: vMinutes > 1 ? 'minutes' : 'minute'
                              , fr: vMinutes > 1 ? 'minutes' : 'minute', es: vMinutes > 1 ? 'minutos' : 'minuto', id: 'menit', ja: '分', zh: '分钟', ko: '분', hi: 'मिनट', ar: vMinutes > 1 ? 'دقائق' : 'دقيقة' })
                          )
                        : null
                ];

            fValue = fValue.filter((v) => Boolean(v)).join(' ');

            newValue = fValue;
        }

        if (dataType === 'join') {
            if (cell.customCellValue) newValue = cell.customCellValue(data);
            var fields = cell.fields;
            if (fields instanceof Array) {
                var ar = [];

                for (let i = 0; i < fields.length; i++) {
                    const fField = fields[i];

                    var found = this.config.getCnfField(fField, this.tableName);
                    if (found && found.cnfTable) found = this.config.getCnfField(found.cnfField, found.cnfTable ? found.cnfTable : field.cnfTable);
                    if (found && found.visibleSelf) {
                        var visible = AntCondition.isVisible(data, {
                            visible: found.visibleSelf
                        });
                        if (!visible) continue;
                    }

                    var valueField = found && found.lookup && found.lookup.valueField ? found.lookup.valueField : 'code';
                    var displayField = found && found.lookup && found.lookup.displayField ? found.lookup.displayField : 'name';
                    var values = found && found.lookup && found.lookup.values instanceof Array ? found.lookup.values : [];
                 
                    var fValue = data[fField];
                    if (fValue != null) {
                        var obj = values.find((f) => f[valueField] === fValue);
                        if (obj) fValue = obj[displayField];
                    }
                    fValue = AntLocalization.translateText(fValue);

                    if (typeof fValue === 'string') fValue = String(fValue);
                    if (fValue === AntLocalization.translateText({ vi: 'Không', en: 'None', fr: 'Aucun', es: 'Ninguno', id: 'Tidak ada', ja: 'なし', zh: '无', ko: '없음', hi: 'कोई नहीं', ar: 'لا شيء' }) && cell.displayNoneAsEmpty !== false) fValue = '';
                    if (fValue === null || fValue === undefined) fValue = '';

                    if (fValue && parseInt(fValue) && String(fField).endsWith('_adm2_name'))
                        fValue = AntLocalization.translateText({ vi: 'Quận', en: 'Dist', fr: 'District', es: 'Distrito', id: 'Distrik', ja: '地区', zh: '区', ko: '구역', hi: 'जिला', ar: 'منطقة' }) + ' ' + fValue;

                    ar.push(fValue);
                }
                newValue = ar
                    .filter((f) => Boolean(f))
                    .map((f) => String(f))
                    .join(cell.separator ? cell.separator : ', ');
            }
        }

        if (dataType === 'first') {
            if (cell.customCellValue) newValue = cell.customCellValue(data);
            var fields = cell.fields;
            if (fields instanceof Array) {
                var ar = [];

                for (let i = 0; i < fields.length; i++) {
                    const fField = fields[i];

                    var found = this.config.getCnfField(fField, this.tableName);
                    if (found && found.cnfTable) found = this.config.getCnfField(found.cnfField, found.cnfTable ? found.cnfTable : field.cnfTable);
                    if (found && found.visibleSelf) {
                        var visible = AntCondition.isVisible(data, {
                            visible: found.visibleSelf
                        });
                        if (!visible) continue;
                    }
                    var valueField = found && found.lookup && found.lookup.valueField ? found.lookup.valueField : 'code';
                    var displayField = found && found.lookup && found.lookup.displayField ? found.lookup.displayField : 'name';
                    var values = found && found.lookup && found.lookup.values instanceof Array ? found.lookup.values : [];
                  
                    var fValue = data[fField];
                    if (fValue != null) {
                        var obj = values.find((f) => f[valueField] === fValue);
                        if (obj) fValue = obj[displayField];
                    }

                    fValue = AntLocalization.translateText(fValue);

                    if (typeof fValue === 'string') fValue = String(fValue);
                    if (fValue === AntLocalization.translateText({ vi: 'Không', en: 'None', fr: 'Aucun', es: 'Ninguno', id: 'Tidak ada', ja: 'なし', zh: '无', ko: '없음', hi: 'कोई नहीं', ar: 'لا شيء' }) && cell.displayNoneAsEmpty !== false) fValue = '';
                    if (fValue === null || fValue === undefined) fValue = '';
                    ar.push(fValue);
                }
                newValue = ar
                    .filter((f) => Boolean(f))
                    .map((f) => String(f))
                    .shift();
            }
        }

        if (dataType === 'last') {
            if (cell.customCellValue) newValue = cell.customCellValue(data);
            var fields = cell.fields;
            if (fields instanceof Array) {
                var ar = [];

                for (let i = 0; i < fields.length; i++) {
                    const fField = fields[i];

                    var found = this.config.getCnfField(fField, this.tableName);
                    if (found && found.cnfTable) found = this.config.getCnfField(found.cnfField, found.cnfTable ? found.cnfTable : field.cnfTable);
                    if (found && found.visibleSelf) {
                        var visible = AntCondition.isVisible(data, {
                            visible: found.visibleSelf
                        });
                        if (!visible) continue;
                    }

                    var valueField = found && found.lookup && found.lookup.valueField ? found.lookup.valueField : 'code';
                    var displayField = found && found.lookup && found.lookup.displayField ? found.lookup.displayField : 'name';
                    var values = found && found.lookup && found.lookup.values instanceof Array ? found.lookup.values : [];
                
                    var fValue = data[fField];
                    if (fValue != null) {
                        var obj = values.find((f) => f[valueField] === fValue);
                        if (obj) fValue = obj[displayField];
                    }
                    fValue = AntLocalization.translateText(fValue);

                    if (typeof fValue === 'string') fValue = String(fValue);
                    if (fValue === AntLocalization.translateText({ vi: 'Không', en: 'None', fr: 'Aucun', es: 'Ninguno', id: 'Tidak ada', ja: 'なし', zh: '无', ko: '없음', hi: 'कोई नहीं', ar: 'لا شيء' }) && cell.displayNoneAsEmpty !== false) fValue = '';
                    if (fValue === null || fValue === undefined) fValue = '';
                    ar.push(fValue);
                }
                newValue = ar
                    .filter((f) => Boolean(f))
                    .map((f) => String(f))
                    .pop();
            }
        }

        if (cell.prefix || (cellCnf && cellCnf.prefix)) {
            let strPrefix = AntCondition.getValue(data, cell.prefix ? cell.prefix : cellCnf.prefix);
            if (strPrefix) newValue = AntLocalization.translateText(strPrefix) + ' ' + String(newValue);
        }
        if (cell.postfix || (cellCnf && cellCnf.postfix)) {
            let strPostfix = AntCondition.getValue(data, cell.postfix ? cell.postfix : cellCnf.postfix);
            if (strPostfix) newValue = String(newValue) + ' ' + AntLocalization.translateText(strPostfix);
        }

        if (cell.showWithText) {
            let strText = '';

            if (cell.rawLabel) {
                var gLabel = AntCondition.getValue(data, cell.rawLabel);
                strText = AntLocalization.translateText(gLabel);
            }
            if (!strText && cell.label) {
                var gLabel = AntCondition.getValue(data, cell.label);
                strText = AntLocalization.translateText(gLabel);
            }

            if (!strText && cellCnf && cellCnf.rawLabel) {
                var gLabel = AntCondition.getValue(data, cellCnf.rawLabel);
                strText = AntLocalization.translateText(gLabel);
            }

            if (!strText && cellCnf && cellCnf.label) {
                var gLabel = AntCondition.getValue(data, cellCnf.label);
                strText = AntLocalization.translateText(gLabel);
            }
            // if (strText) newValue = strText + ': ' + String(newValue);
            if (strText) newValue = strText + ' ' + String(newValue);
        }

        return newValue;
    }

    isRowVisible({ props, row, item, index }) {
        var vCells = [];

        for (let i = 0; i < row.cells.length; i++) {
            let cell = row.cells[i];

            let vCellValue = item[cell.dataField];
            if (
                cell.dataField &&
                cell.hideWhenEmpty &&
                (vCellValue === undefined || vCellValue === 0 || vCellValue === null || String(vCellValue).trim() === '')
            )
                continue;

            let visible = this.isFieldVisible(props, cell, item);

            if (visible) {
                var cnfTable = cell.cnfTable ? cell.cnfTable : this.tableName;
                var cellCnf = this.initFieldConfig({
                    dataField: cell.dataField,
                    dataType: cell.dataType,
                    cnfTable: cnfTable,
                    cnfField: cell.cnfField
                });

                vCellValue = this.formatFieldValue(props, cell, item, vCellValue, cellCnf);

                if (vCellValue !== undefined && vCellValue !== null && String(vCellValue).trim() !== '') {
                    vCells.push(cell);
                }
            }
        }

        return vCells.length > 0;
    }

    getVisibileRows(args) {
        var vRows = [];

        for (let i = 0; i < args.layout.rows.length; i++) {
            const row = args.layout.rows[i];
            let isVisible = this.isRowVisible({
                props: args.props,
                row: row,
                item: args.item,
                index: i
            });
            if (isVisible) {
                vRows.push(row);
            }
        }

        return vRows;
    }

    getVisibileRowsCount(card) {
        let header = [];
        let footer = [];
        let main = [];
        let actionPanel = [];

        if (card.cardLayout && card.cardLayout.header)
            header = this.getVisibileRows({
                props: card.props,
                layout: card.cardLayout.header,
                item: card.item,
                key: 'header'
            });

        if (card.cardLayout && card.cardLayout.footer)
            footer = this.getVisibileRows({
                props: card.props,
                layout: card.cardLayout.footer,
                item: card.item,
                key: 'footer'
            });

        if (card.cardLayout && card.cardLayout.main)
            main = this.getVisibileRows({
                props: card.props,
                layout: card.cardLayout.main,
                item: card.item,
                key: 'main'
            });

        return header.length + main.length + footer.length;
    }
}
